import { Capacitor } from "@capacitor/core";
import { isMobile, isSafari } from "react-device-detect";

import { useTranslation } from "@/core/i18n";
import { useAppsFlyerBannerDetection } from "@/services/DeepLinkService";
import { Button } from "atoms/button/Button";
import { Icon } from "atoms/icon/Icon";
import RepeatMDLogo from "atoms/icon/icons/asset_Repeat_app_icon_small_ol.svg";
import { isNativeMobileApp } from "utils/platform.helpers";

interface OpenMobileAppBannerProps {
  onClick?: () => void;
}

export const OpenMobileAppBanner = (props: OpenMobileAppBannerProps) => {
  const { t } = useTranslation();
  const appsFlyerBannerExists = useAppsFlyerBannerDetection();
  if (appsFlyerBannerExists || !isMobile || isSafari || isNativeMobileApp()) {
    return null;
  }

  return (
    <div className="flex items-center justify-between border-b-[0.75px] border-light-grey px-3 py-2 text-left">
      <div className="flex items-center gap-2">
        <Icon svg={RepeatMDLogo} />
        <div className="text-body2">{t("openMobileAppBanner.openInApp")}</div>
      </div>
      <div>
        <Button onClick={props.onClick} size="xsmall">
          {t("openMobileAppBanner.open")}
        </Button>
      </div>
    </div>
  );
};
